import type { MoreMenuCopy } from '@/app/(site)/chrome-copy'

/**
 * The nav's More dropdown.
 *
 * About and Artists are translated. Stickers and Apps are not, deliberately:
 * "Stickers" is a GIPHY product name rather than a common noun and is never
 * translated anywhere in the app, and the Apps section is a single brand name.
 * Brand names inside the translated sections stay as they are for the same
 * reason.
 *
 * Several of these links leave the site for English-only destinations, which is
 * why the split is by section rather than translating everything. See
 * docs/solutions/localization-known-gaps.md.
 */
export const getMoreList = (copy: MoreMenuCopy) => [
    {
        header: copy.about,
        items: [
            { label: copy.team, href: '/team' },
            // Brand name.
            { label: 'GIPHY Studios', href: '/giphystudios' },
            { label: copy.developers, href: 'https://developers.giphy.com/' },
            {
                label: copy.applyAsABrand,
                href: 'https://support.giphy.com/hc/en-us/articles/360019977992-Apply-For-A-Brand-Channel',
            },
            { label: copy.faq, href: 'https://support.giphy.com/hc/en-us' },
            { label: copy.support, href: 'https://support.giphy.com/hc/en-us' },
            { label: copy.transparency, href: 'transparency/2024' },
            {
                label: copy.jobs,
                href: 'https://careers.shutterstock.com/us/en/search-results?keywords=giphy',
            },
        ],
    },
    {
        header: copy.artists,
        items: [
            { label: copy.artistDirectory, href: '/artists' },
            {
                label: copy.hireAnArtist,
                href: 'https://support.giphy.com/hc/en-us/articles/360022661172-How-to-Hire-an-Artist-on-GIPHY',
            },
        ],
    },
    {
        // Product name. Never translated, here or anywhere else.
        header: 'Stickers',
        items: [
            { label: 'Originals', href: '/originals/stickers/studios-stickers' },
            { label: 'Trending', href: '/stickers/trending' },
            { label: 'Reactions', href: '/stickers/reactions' },
            { label: 'Packs', href: '/stickers/packs' },
        ],
    },
    {
        header: 'Apps',
        items: [{ label: 'GIPHY Capture', href: '/apps/giphycapture' }],
    },
]
